import React, { FC, useCallback, useState } from 'react';
import dynamic from 'next/dynamic';
import { SessionType } from 'src/api/learningSessions/types';
import { OriginPage } from './types';
import DevToolsTrigger from './DevToolsTrigger';
import { useDevToolPermissions } from './utils';

interface Props {
  page?: OriginPage;
  sessionType?: SessionType;
  languagePairId?: number;
  className?: string;
  setCountry?: (country: string) => void;
}

const DevToolsModal = dynamic(() => import('./DevToolsModal'));

const DevTools: FC<Props> = ({ page, sessionType, languagePairId, className, setCountry }) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [wasOpened, setWasOpened] = useState<boolean>(false);
  const toggleModal = useCallback(() => {
    setWasOpened(true);
    setShowModal(v => !v);
  }, [setShowModal]);

  if (!useDevToolPermissions()) return null;

  return (
    <>
      <DevToolsTrigger onClick={toggleModal} className={className} />
      {wasOpened && (
        <DevToolsModal
          isOpen={showModal}
          handleClose={toggleModal}
          page={page}
          sessionType={sessionType}
          languagePairId={languagePairId}
          setCountry={setCountry}
        />
      )}
    </>
  );
};

export default DevTools;
